import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ParametroIntegraXSmsModel } from '../model/parametros/parametro-integrax-sms.model';

@Injectable({ providedIn: 'root' })
export class ParametroIntegraXSmsService {
  private readonly http = inject(HttpClient);

  private readonly urlBase = `${environment.urlBase}/parametro-integrax-sms`;

  buscar(): Observable<ParametroIntegraXSmsModel> {
    return this.http.get<ParametroIntegraXSmsModel>(this.urlBase);
  }

  salvar(parametro: ParametroIntegraXSmsModel): Observable<void> {
    return this.http.post<void>(this.urlBase, parametro);
  }
}
